import { useRef, useState, useEffect } from 'react';
import '@geoapify/geocoder-autocomplete/styles/minimal.css';
import {
    GeoapifyGeocoderAutocomplete,
    GeoapifyContext
} from '@geoapify/react-geocoder-autocomplete';
import Map from './Map';
import L from 'leaflet';
import { MDBRow } from 'mdb-react-ui-kit';

const Autocomplete = (props) => {
    const key = process.env.REACT_APP_GEOAPIFY_API_KEY;
    const [addressInputValue, setAddressInputValue] = useState();
    const [map, setMap] = useState();
    const didMount = useRef(false);
    const [addrData, setAddrData] = useState({});
    const filterByCountryCode = ["sk"];
    const biasByCountryCode = ["sk"];
    const language = ["sk"];

    useEffect(() => {
        if (!didMount.current) {
            didMount.current = true;
            return;
        }
        props.handler(createAddress(addrData))
    }, [addrData])

    if (map != undefined && props.mapUpdate) {
        setTimeout(function () { map.invalidateSize() }, 1000);
    }

    function createAddress(e) {
        let ulice = "", obec, psc, lat, lon, address = "";
        //mapy.cz geolocation address
        if (e.properties == undefined) {
            if (!e.position) return "";
            (e.regionalStructure || []).forEach(val => {
                switch (val.type) {
                    case 'regional.address':
                        ulice = ulice + " " + val.name;
                        break;
                    case 'regional.street':
                        ulice = val.name + ulice;
                        break;
                    case 'regional.municipality':
                        obec = val.name;
                        break;
                    default:
                        break;
                }
            })
            psc = e.zip ? e.zip.replace(/\s/g, '') : "";
            lat = e.position.lat;
            lon = e.position.lon;
            address = ulice + "," + obec + "," + psc + "," + lat + "," + lon;
        } else {//geoapify geolocation address
            ulice = e.properties.street ? e.properties.street : e.properties.name;
            if (e.properties.housenumber != undefined) ulice += " " + e.properties.housenumber;
            obec = e.properties.city ? e.properties.city : "";
            psc = e.properties.postcode ? e.properties.postcode.replace(/\s/g, '') : "";
            lat = e.properties.lat;
            lon = e.properties.lon;
            address = ulice + "," + obec + "," + psc + "," + lat + "," + lon;
        }
        return address;
    }

    function mapSetHandler(map) {
        setMap(map);
    }
    function mapClickHandler(address) {
        //Reverse geolocation - geoapify
        //setAddressInputValue(address.properties.formatted);
        //setAddrData(address);

        //Reverse geolocation - mapy.cz
        setAddressInputValue(address.name + ', ' + address.location);
        setAddrData(address);
    }
    function onPlaceSelect(e) {
        if (e == undefined || e == null) return;
        map.invalidateSize(true);
        map.setView([e.properties.lat, e.properties.lon], 16)
        let addressLine = e.properties.address_line1 + ", " + e.properties.address_line2;
        L.popup().setLatLng([e.properties.lat, e.properties.lon]).setContent(addressLine).openOn(map);
        setAddrData(e);
    }


    return (
        <div className='mb-4'>
            <MDBRow className='mb-3' id='mapAutocompleteDiv'>
                <GeoapifyContext apiKey={key}>
                    <GeoapifyGeocoderAutocomplete
                        placeholder="Zadajte adresu"
                        value={addressInputValue}
                        filterByCountryCode={filterByCountryCode}
                        biasByCountryCode={biasByCountryCode}
                        lang={language}
                        debounceDelay='300'
                        skipIcons='true'
                        allowNonVerifiedHouseNumber='true'
                        allowNonVerifiedStreet='true'
                        placeSelect={(e) => onPlaceSelect(e)}
                    />
                </GeoapifyContext>
            </MDBRow>
            <Map clickHandler={mapClickHandler} callbackHandler={mapSetHandler} />
        </div>
    )
}

export default Autocomplete

